<template>
  <div v-if="item" class="m-top-2">
    <WidgetSliderSwiper class="gallery" :length="item.slide.length">
      <template
        v-for="(slide, index) in item.slide"
        :key="index"
        #[`slide-${index}`]
      >
        <GallerySlide :item="slide" />
      </template>
    </WidgetSliderSwiper>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<script>
export default {
  name: 'Gallery',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
